// istanbul ignore file

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const context: any = getGlobalContext();

/**
 * Returns "global" for tests
 * @returns {*}
 */
function getGlobalContext() {
  if (typeof window !== 'undefined') {
    return window;
  }

  if (typeof global !== 'undefined') {
    return global;
  }

  return {
    dataLayer: [],
  };
}

export const trackEventEx = ({ eventCategory, eventAction, eventLabel }: { eventCategory: string; eventAction: string; eventLabel: string }) => {
  if (process.env.NODE_ENV === 'test') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-return
  context.dataLayer.push({
    eventCategory,
    eventAction,
    eventLabel,
    event: eventCategory ? 'event to GA' : 'generic event',
  });
};
